module.exports = __webpack_public_path__ + "img/btn.67445625.png";